export default "__VITE_ASSET__DnB58lFy__"